import type { Order } from '__models__'
import forEach from 'lodash-es/forEach'

import type { SelectOption } from '@fourthwall/components'
import type { WeightUnit } from '@fourthwall/services/dist/models/common'

export const getNumberOfProducts = (
  items: Order['offers'],
  donation?: Order['donation'],
): number => {
  let itemsCount = 0

  forEach(items, ({ quantity }) => {
    itemsCount += quantity
  })

  if (donation) {
    itemsCount += 1
  }

  return itemsCount
}

export const getWeightOptions = (): SelectOption[] => {
  const labels: Record<WeightUnit, string> = {
    lb: 'lb',
    oz: 'oz',
    g: 'g',
    kg: 'kg',
  }

  return Object.entries(labels).map<SelectOption>(([value, label]) => ({ label, value }))
}
